import router from '@/router'
import store from '@/store'
import ProjectIcon from '@core/components/project-icon/ProjectIcon.vue'

export default [
	{
		title: 'Disease Alerts',
		route: 'disease-alerts',
		icon: 'AlertTriangleIcon',
		get tag() {
			const count = store.getters['features/activeAlertCount']
			return count > 0 ? String(count) : null
		},
		tagVariant: 'danger',
	},
	{
		title: 'Analytics',
		route: 'super-admin-analytics',
		icon: 'BarChart2Icon',
		roles: ['super_admin'],
	},
	{
		title: 'Company',
		route: 'apps-company-detail',
		icon: 'UsersIcon',
		roles: ['super_admin'],
	},
	{
		title: 'Vet Approvals',
		route: 'super-admin-vet-approvals',
		icon: 'UserCheckIcon',
		roles: ['super_admin'],
	},
	// {
	// 	title: "Users",
	// 	icon: "UserIcon",
	// 	roles: ["super_admin"],
	// 	children: [],
	// },
	// {
	// 	title: " Summary",
	// 	route: "apps-company-hatchery-summary",
	// 	icon: "UsersIcon",
	// 	roles: ["super_admin"],
	// },
	{
		title: 'Roles',
		route: 'apps-roles',
		icon: 'UsersIcon',
		roles: ['super_admin'],
	},
	{
		title: 'Permission',
		route: 'apps-permission',
		icon: 'UsersIcon',
		roles: ['super_admin'],
	},
	{
		header: 'Hygiene Testing',
	},
	{
		title: 'Hygicult MMF',
		route: 'super-admin-hygicult',
		icon: 'ActivityIcon',
		roles: ['super_admin'],
	},
]

// router.beforeEach((to, from, next) => {
// 	if (to.matched.some((data) => data.meta.permissions)) {
// 		if (record.meta.permissions) {
// 		}
// 	}
// });
